<!--mockups are hinting that these will be different enough for each pki
to merit kpi component doing its own thing-->
<div class="kpi-context-container">
    <div class="kpi-stat">
        <div class="cc-placeholder">&nbsp;</div>
    </div>
    <div class="kpi-context-controls">
        <button
            cmpsButton
            (click)="_onCreateEventClick($event)"
        >
            <cmps-icon svgIcon="calendar-range"></cmps-icon>
            <span cmpsButtonLabel>{{
                _i18n._9605_CREATE_EVENT | translate
            }}</span>
        </button>

        <div
            class="d-flex align-items-center mx-4"
            data-cc="period-range"
        >
            <span>{{ _i18n._7357_SHOWING | translate }}</span>
            <button
                class="btn bg-transparent p-0 ml-1 cc-primary"
                data-e2e="button-period-range"
                (click)="_onPeriodClick()"
            >
                <span
                    >{{ state?.maxShown }}&nbsp;{{
                        _i18n._9607_WEEKS | translate
                    }}</span
                >
            </button>
        </div>

        <div class="d-flex align-items-center mx-4">
            <button
                class="btn bg-transparent p-0 mr-4 cc-primary"
                [disabled]="!state?.periodCanGoLeft"
                data-e2e="button-previous-period-date-range"
                (click)="_onPreviousPeriodClick()"
            >
                <cmps-icon
                    class="mr-1"
                    svgIcon="arrow-left"
                ></cmps-icon>
                <span>{{ _i18n._9608_PREVIOUS_WEEK | translate }}</span>
            </button>
            <button
                class="btn bg-transparent p-0 ml-4 cc-primary"
                [disabled]="!state?.periodCanGoRight"
                data-e2e="button-next-period-date-range"
                (click)="_onNextPeriodClick()"
            >
                <span>{{ _i18n._9609_NEXT_WEEK | translate }}</span>
                <cmps-icon
                    class="ml-1"
                    svgIcon="arrow-right"
                ></cmps-icon>
            </button>
        </div>
    </div>
</div>

<div
    cmpsCoachingCoverageGrid
    [columns]="state?.gridColumns"
    [rows]="state?.gridRows"
    [sortDefs]="state?.gridSortDefs"
    [columnsNeedResize]="state?.gridColumnsNeedResize"
    [needsLayout]="state?.gridNeedsLayout"
    [rosterType]="state?.rosterType"
    (sortChange)="_onSortChange($event)"
    (togglePeriodColumnClick)="_onTogglePeriodColumnClick($event)"
    (toggleRowExpandClick)="_onToggleRowExpandClick($event)"
    (periodClick)="_onGridPeriodClick($event)"
    (rosterTypeChange)="_onRosterTypeChange($event)"
    (scheduleForUserClick)="_onScheduleForUserClick($event)"
    (otherScheduleItemsClick)="_onOtherScheduleItemsClick($event)"
></div>
